import { GetterTree } from 'vuex';
import { State } from './detail.store';

const getters: GetterTree<State, State> = {
  getCurrentSubType: state => {
    return state.currentSubType;
  },
  getDatabaseInstances: state => {
    return state.databaseInstances;
  },
  getCurrentDatabaseInstance: state => {
    return state.currentDatabaseInstance;
  },
  getBuckets: state => {
    return state.buckets;
  },
  getCurrentBucket: state => {
    return state.currentBucket;
  },
  getClusters: state => {
    return state.clusters;
  },
  getCurrentCluster: state => {
    return state.currentCluster;
  },
};
export default getters;
